
import { InputRadio, LabelRadio } from './styles';

export default ({ input, data, label, checked, meta: { error, touched } }) => {
  return  <p>
    <InputRadio {...input} value={data} checked={checked} type="radio" id={label} />
    <LabelRadio  htmlFor={label} error={error && touched}>{label}</LabelRadio>
  </p>;
};